import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import type { PaperListResponse, PaperWithRole } from "@/types/paper";

export function useNotes(conceptId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { paperId: string; notes: string }) =>
      apiClient
        .patch(`api/concepts/${conceptId}/papers/${data.paperId}`, {
          json: { notes: data.notes },
        })
        .json<PaperWithRole>(),
    onSuccess: (updated) => {
      queryClient.setQueriesData<PaperListResponse>(
        { queryKey: ["papers", conceptId] },
        (old) =>
          old
            ? {
                ...old,
                papers: old.papers.map((p) =>
                  p.id === updated.id
                    ? { ...p, notes: updated.notes }
                    : p,
                ),
              }
            : old,
      );
      // Also keep the per-paper cache (used by useConceptPaper for the
      // Analyze + Map detail panes) in sync, so cross-route navigation
      // shows fresh notes immediately instead of waiting for refetch.
      queryClient.setQueryData<PaperWithRole>(
        ["concept-paper", conceptId, updated.id],
        (old) => (old ? { ...old, notes: updated.notes } : old),
      );
    },
  });
}
